import styled from "@emotion/styled"
import Link from "components/Link"

const ListFourItemLink = styled(Link)`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 19px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  letter-spacing: 0.06em;
  display: block;
  border-bottom: 1px solid transparent;
  transition: all 0.2s;
  margin-bottom: -1px;
  max-width: max-content;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export default ListFourItemLink
